export default __webpack_public_path__ + "static/media/letter-in-box.61da1ba9.svg";